<template>
  <!-- About / Contact / Privacy. The backend pre-renders this same markup into #app
       from content/pages.json (render_content_page_html in backend/app.py),
       so crawlers get the full text without running JS. Keep the two in sync. -->
  <div class="guide-page">
    <content-header :path="`/${key}`" />
    <main class="guide-main">
      <article class="guide-article">
        <h1>{{ page.title }}</h1>
        <p v-if="page.updated" class="guide-meta">{{ page.updated }}</p>
        <p class="guide-lead">{{ page.lead }}</p>
        <div class="guide-body" v-html="page.body.join('\n')"></div>
        <p v-if="key === 'privacy'" class="guide-start">
          <button class="guide-start-link" @click="openConsentSettings">{{ $t('consent.settings') }}</button>
        </p>
      </article>
    </main>
    <content-footer />
  </div>
</template>

<script>
import pages from '../public/content/pages.json';
import { applySeo } from './i18n/head';
import ContentHeader from './components/ContentHeader.vue';
import ContentFooter from './components/ContentFooter.vue';
import { openConsentSettings } from './consent';

export default {
  components: { ContentHeader, ContentFooter },
  computed: {
    key() {
      return this.$route.meta.page;
    },
    page() {
      return pages.pages[this.key][this.$locale];
    }
  },
  watch: {
    '$route'() {
      this.updateSeo();
      window.scrollTo(0, 0);
    }
  },
  created() {
    this.updateSeo();
  },
  methods: {
    openConsentSettings,
    updateSeo() {
      applySeo({
        locale: this.$locale,
        routeBase: this.key,
        title: this.page.metaTitle,
        description: this.page.metaDescription
      });
    }
  }
};
</script>
